import Vue from 'vue';
// eslint-disable-next-line import/no-named-as-default
import Multiselect from 'vue-multiselect';
import SvgIcon from '@/components/global/SvgIcon.vue';

// eslint-disable-next-line vue/multi-word-component-names
Vue.component('Multiselect', Multiselect);
Vue.component('SvgIcon', SvgIcon);
